import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, signal } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { SETTINGS, Settings } from '../app.settings';

export type ProfileType = {
  givenName?: string;
  surname?: string;
  userPrincipalName?: string;
  displayName?: string;
  mail?: string;
  id?: string;
};

@Injectable({
  providedIn: 'root'
})
export class MSGraphService {
  baseUrl = 'https://graph.microsoft.com/';
  profile = signal<ProfileType | undefined>(undefined);

  constructor(
    @Inject(SETTINGS) private settings: Settings,
    private httpClient: HttpClient
  ) {}

  getMyPhoto$(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'image/jpeg'
      }),
      responseType: 'blob' as const
    };
    return this.httpClient.get(this.baseUrl + 'v1.0/me/photo/$value', httpOptions).pipe(shareReplay(1));
  }

  getUserPhoto$(emailAddress: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'image/jpeg'
      }),
      responseType: 'blob' as const
    };
    return this.httpClient.get(this.baseUrl + `v1.0/users/${emailAddress}/photo/$value`, httpOptions).pipe(shareReplay(1));
  }

  getMyProfile$(): Observable<ProfileType> {
    return this.httpClient.get(this.baseUrl + `v1.0/me`).pipe(shareReplay(1));
  }

  getUserProfile$(email: string): Observable<ProfileType> {
    return this.httpClient.get(this.baseUrl + `v1.0/users/${email}`).pipe(shareReplay(1));
  }
}
